import { IApplicationState, TThunkAction } from '../../types/redux';

/** Thunk для доступа к данным из стейта для передачи в события аналитики */
// export const getState: TThunkAction<IApplicationState> = (_, getState) => getState();

export const connectState =
  (fn: (state: IApplicationState) => void): TThunkAction =>
  (_, getState) =>
    fn(getState());
